(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@sbi/styleguide", [], factory);
	else if(typeof exports === 'object')
		exports["@sbi/styleguide"] = factory();
	else
		root["@sbi/styleguide"] = factory();
})(window, function() {
return 